import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button';
import { productRandomListSelector } from '../../store/selectors/ProductRecommendations';
import style from './RecommendationsCard.module.scss';

function RecommendationsCard() {
    const allCatalog = useSelector(productRandomListSelector);

    return (
        <div className={style.recommendations}>
            <h2 className={style.title}>
                Рекомендовано для вас
            </h2>

            <Button name={'Показати більше'} link={`/catalog/${allCatalog[0]?.catalog?.id}`} />
        </div>
    );
}

export default React.memo(RecommendationsCard);

